'use client';

import { useVideoProgressPosition } from '@vimond/features/resume-watching/hooks/useVideoProgressPosition';
import { useLocale } from '@vimond/i18n';
import { AssetType } from '@vimond/services/content-discovery';

type Props = {
  asset: AssetType;
};

export const VideoProgressBar = ({ asset }: Props) => {
  const { locale } = useLocale();
  const { progress } = useVideoProgressPosition(asset.id, locale);
  if (!asset.duration) return <></>;
  const completionRate = (progress / asset.duration) * 100;
  return (
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-black bg-opacity-50">
      <div
        className={`bg-text-highlight h-full`}
        style={{ width: completionRate + '%' }}
      ></div>
    </div>
  );
};
